import React, { memo, useCallback, useMemo } from 'react';

import { MoreButtonCDS } from '@sharedCR/coreDesignSystem/Buttons';
import {
  ArrowCheckIcon,
  ConfirmIcon,
  DeleteIcon,
  EditPenIcon,
} from '@sharedCR/coreDesignSystem/icons';
import MenuPopoverCDS from '@sharedCR/coreDesignSystem/MenuPopoverCDS';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import usePopover from 'hooks/usePopover';

const InvestorConditionActions = ({
  row,
  isEditAllowed,
  onEdit,
  onDelete,
  onMarkResponded,
  onMarkCleared,
}) => {
  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  const handleEdit = useCallback(() => {
    onClearAnchorElement();
    onEdit(row);
  }, [onEdit, row, onClearAnchorElement]);

  const handleDelete = useCallback(() => {
    onClearAnchorElement();
    onDelete(row.key);
  }, [onDelete, row.key, onClearAnchorElement]);

  const handleMarkResponded = useCallback(() => {
    onClearAnchorElement();
    onMarkResponded(row.key);
  }, [onMarkResponded, row.key, onClearAnchorElement]);

  const handleMarkCleared = useCallback(() => {
    onClearAnchorElement();
    onMarkCleared(row.key);
  }, [onMarkCleared, row.key, onClearAnchorElement]);

  const items = useMemo(
    () => [
      { text: 'Edit', onClick: handleEdit, icon: <EditPenIcon size={IconSize[20]} /> },
      {
        text: 'Mark as Responded',
        onClick: handleMarkResponded,
        icon: <ArrowCheckIcon size={IconSize[20]} />,
      },
      {
        text: 'Mark as Cleared',
        onClick: handleMarkCleared,
        icon: <ConfirmIcon size={IconSize[20]} />,
      },
      {
        text: 'Delete Condition',
        onClick: handleDelete,
        icon: <DeleteIcon size={IconSize[20]} />,
      },
    ],
    [handleEdit, handleMarkResponded, handleMarkCleared, handleDelete],
  );

  return (
    <>
      <MoreButtonCDS
        disabled={!isEditAllowed}
        isSelected={!!anchorEl}
        onClick={onSetAnchorElement}
      />

      <MenuPopoverCDS anchorEl={anchorEl} items={items} onClose={onClearAnchorElement} />
    </>
  );
};

InvestorConditionActions.propTypes = {
  row: PropTypes.shape({
    key: PropTypes.string.isRequired,
  }).isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onMarkResponded: PropTypes.func.isRequired,
  onMarkCleared: PropTypes.func.isRequired,
};

export default memo(InvestorConditionActions);
